import './design.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import { BrandProvider } from './brand.js';
import { AuthProvider } from './auth.js';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root missing');
createRoot(rootEl).render(
  <React.StrictMode>
    <BrandProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrandProvider>
  </React.StrictMode>,
);
